import * as React from "react";

import { Layout } from "components/organisms/Layout";
import { Promo } from "components/organisms/Promo";
import { ModalForm } from "components/organisms/ModalForm";
import {BackgroundImage} from "components/organisms/BackgroundImage";
import { ReviewsSlider } from "components/organisms/ReviewsSlider";

import * as pageStyles from 'styles/pages/template/template.module.scss';
import cls from "classnames";

import {graphql, type HeadFC, withAssetPrefix} from "gatsby";
import type { GatsbyTypes } from "gatsby-types";
import { reviews } from "data/unified-java-runtime/reviews";
import { StaticImage } from "gatsby-plugin-image";

const bgColor = "bg-cyan"

interface Props {
    data: GatsbyTypes.Query
}

const IndexPage: React.FC<Props> = ({ data }) => {
    return (
        <Layout button={{className: bgColor}}
            forms={data.allFormsJson.nodes}
        >
            <BackgroundImage
            alt={"BG Image"}
            className={pageStyles.bg}
            desktop={
                <StaticImage src={"../../images/pages/template/promo-desktop.png"} alt={""} />
            }
            tablet={
                <StaticImage src={"../../images/pages/template/promo-mobile.png"} alt={""} />
            }
            mobile={
                <StaticImage src={"../../images/pages/template/promo-mobile.png"} alt={""} />
            }
            >
                <Promo
                    title={"Discover the Seven Key Benefits of Liberica JDK"}
                    className={cls(pageStyles.promocontainer)}
                    description={<div className={cls("p-2", pageStyles.pageDescription)}>
                        <p className={"color-gray"}>
                            The recent changes in the licensing policy of Oracle Java, many companies are
                            reassessing their investments and looking for alternatives.
                            This is where Liberica JDK comes in.
                        </p>
                        <p className={"color-white"}>Liberica JDK is a 100% open-source and TCK-verified Java runtime.
                            But what sets Liberica JDK apart from other OpenJDK distributions?</p>
                        <p className={"color-white"}>
                            Dive into our guide to uncover the seven key benefits that make
                            Liberica JDK the ultimate choice for your Java needs.
                        </p>
                    </div>}
                    additionalContentNode={(<div className={pageStyles.successModal}>
                        <ModalForm
                            title={<p className={pageStyles.formTitle}>Get Your Guide</p>}
                            classNames={{
                                details: pageStyles.formDetails
                            }}
                            form={{
                                items: [
                                    {
                                        name: 'firstname',
                                        placeholder: 'Name',
                                        gridColumn: '1/3'
                                    },
                                    {
                                        name: 'company',
                                        placeholder: 'Company',
                                        gridColumn: '1/3'
                                    },
                                    {
                                        name: 'email',
                                        required: true,
                                        placeholder: 'Work e-mail',
                                        gridColumn: '1/3'
                                    },
                                    {
                                        name: 'mobilephone',
                                        placeholder: 'Phone',
                                        gridColumn: '1/3'
                                    },
                                ],
                                formId: "73719293-3720-423e-964c-0ef3d60f5d43",
                                controls: {
                                    terms: {
                                        name: "privacystatement",
                                        caption: <span className="color-gray">I agree with <a className={pageStyles.terms} href="/terms-of-use/">Terms</a> and <a className={pageStyles.terms} href="/privacy-policy/">Privacy</a></span>,
                                        className: pageStyles.terms,
                                    },
                                    button: {
                                        caption: "Grab your copy",
                                        className: "button-filled bg-cyan color-white"
                                    }
                                }
                            }}
                            successDetails="Thank you!"
                            successTitle="The whitepaper is on the way to your inbox. We hope you enjoy reading it."
                        /></div>)}
                    additionalContentNodePosition={"end"}
                    buttons={[]}
                />
            </BackgroundImage>

            <ReviewsSlider
                items={reviews}
                title="What customers say about our support"
                theme="dark"
                className={cls(pageStyles.bg, pageStyles.reviews)}
            />
        </Layout>
    )
}

export default IndexPage

export const query = graphql`
    query {
    allFormsJson(filter: {fields: {idSelector: {eq: "popup-contact-form-window"}}}) {
        nodes {
        title
        details
        formId
        eventAction
        fields {
            hashedIdSelector
            idSelector
        }
        items {
            gridColumn
            name
            placeholder
            required
            type
        }
        controls {
            terms {
            name
            }
            button {
            caption
            }
        }
        }
    }
    }
`

export const Head: HeadFC = () => {

    const cover = <StaticImage src={"../../images/pages/7-reasons-to-choose-liberica-jdk/cover.png"} alt={""} />

    return <>
        <title>Discover the Seven Key Benefits of Liberica JDK | BellSoft Java</title>
        <meta name="description" content={"Looking for a Oracle Java Alternative? Download our guide to explore the " +
            "seven key benefits of Liberica JDK, a 100% open-source and TCK-verified Java runtime."}/>
        <meta name="keywords" content={"BellSoft, Java Applications, Java Developers, Java Experts, " +
            "Java Technologies, Software Developers, Java Performance Engineers"}/>
        <meta property="og:image"
              content={withAssetPrefix(cover.props.__imageData.images.fallback.src)}/>
    </>
}
